import { Button, Box } from "../atoms";

export interface ButtonSetProps {
  componentName: string;
  leftBoxText?: string;
  rightBoxText?: string;

  leftBoxHandler?: () => void;
  rightBoxHandler?: () => void;

  disableRightButton?: boolean;
  disableLeftButton?: boolean;
  sx?: Record<string, any>;
}

export const ButtonSet = ({
  componentName,
  leftBoxText = "Cancel",
  rightBoxText = "Save",
  leftBoxHandler = () => {},
  rightBoxHandler = () => {},
  disableRightButton = false,
  disableLeftButton = false,
  sx,
}: ButtonSetProps) => {
  return (
    <Box
      componentName={`${componentName}-button-set`}
      display="flex"
      border={false}
      justifyContent="flex-end"
      alignItems="center"
      sx={sx}
    >
      <Button
        componentName={componentName}
        onClick={leftBoxHandler}
        variant="outlined"
        disabled={disableLeftButton}
      >
        {leftBoxText}
      </Button>
      <Button
        componentName={componentName}
        onClick={rightBoxHandler}
        sx={{ marginLeft: 2 }}
        disabled={disableRightButton}
      >
        {rightBoxText}
      </Button>
    </Box>
  );
};
